import React from 'react';
import { Redirect } from "react-router-dom";

import { setApp, getApp } from '../../../index';

class StepReview extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fireRedirect: false,
            dataExists: false,
            hasFixedFields: true
        };
    }

    // If Edit Button is clicked, redirect to the Step needs review
    editClick = (e) => {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        window.scrollTo(0, 0);
        setApp('review', true); // If review == true, render another button to take applicant back to Review Step
    }

    componentDidMount() {
        //this.state.dataExists = this.props.fixedFields;
        this.setState({
            dataExists: this.props.fixedFields
        });
        
        // If the Review Step does not have fixedFields (e.g. Co-App Info, Co-App Contact, and etc.)
        if (!this.props.fixedFields) {
            var children = this.props.children;
            for (var i = children.length; i--;) { // Loop through the children and check if there is any data exists in state (use appKey to map to state)
                if (children[i].props) {
                    var appKey = children[i].props.appKey;
                    if (appKey) {
                        if (getApp(appKey)) {
                            // this.state.dataExists = true;
                            this.setState({
                                dataExists: true
                            });
                        }
                    }
                }
            }
        }
    }

    render() {
        var stepLink = this.props.stepLink;
        //const dataCheckMate = this.state.dataExists;
        if (this.state.dataExists || this.props.fixedFields) {
            return (
                <div className="step-review">
                    <button className="edit-button" onClick={this.editClick} >Edit</button>
                    {this.state.fireRedirect && (
                        <Redirect to={`/loan-application/${stepLink}`} />
                    )}
                    {this.props.children}
                </div>
            )
        } else {
            return (
                <span></span>
            )
        }
    }
}

export default StepReview;